import { useState } from "react";
import { useTranslation } from "react-i18next";

const EPISODE_DATA = [
  {
    name: "الزيارة (العلاقات الأسرية)",
    name_en: "Visitation (Family Relations)",
  },
  {
    name: "الأنشطة الرياضية والعائلية",
    name_en: "Sports and family activities",
  },
  {
    name: "العلاقة العاطفية مع الوالدين",
    name_en: "Emotional Connection with Parents",
  },
  {
    name: "احترام الوالدين وكبار السن",
    name_en: "Respect for parents and elders",
  },
  {
    name: "عادات الأكل الصحية ونمط الحياة",
    name_en: "Healthy eating habits and lifestyle",
  },
  {
    name: "القضايا الثقافية والهوية المحلية",
    name_en: "Cultural Issues and Local Identity",
  },
  {
    name: "النجاح الشخصي والسعي للمستقبل",
    name_en: "Personal Success and Striving for the Future",
  },
  {
    name: "المستقبل والتخطيط طويل الأجل",
    name_en: "Futurism and long-term planning",
  },
  {
    name: "ماركة سم بایت ومسار نموها",
    name_en: "The Sambite brand and its growth trajectory",
  },
  {
    name: "الوطنية والمسؤولية الاجتماعية والوطنية",
    name_en: "Patriotism, Social and National Responsibility",
  },
  {
    name: "السلام العالمي والصداقة بين الثقافات واللطف العالمي",
    name_en: "World Peace, Intercultural Friendship and Global Kindness",
  },
  {
    name: "القيادة الاجتماعية والتنمية الجماعية وبناء المستقبل",
    name_en:
      "Social Leadership, Collective Development, and Building the Future",
  },
];

export default function EpisodeSelector({ user, onSelectEpisode }) {
  const unlockedEpisode = user?.game?.episode ?? 1;
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.language; // Get the current language from i18n

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 justify-center gap-6 py-8 px-4 bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen pb-20">
      {EPISODE_DATA.map((episodeData, i) => {
        const episode = i + 1;
        const isUnlocked = episode <= unlockedEpisode;

        // Choose the name based on the current language, defaulting to English if Arabic is empty
        const episodeName =
          currentLanguage === "ar" && episodeData.name
            ? episodeData.name
            : episodeData.name_en;

        return (
          <button
            key={episode}
            onClick={() => isUnlocked && onSelectEpisode(episode)}
            className={`
              relative flex flex-col items-center justify-center
              rounded-2xl text-center p-4 shadow-xl transition-all duration-300
              transform hover:scale-105
              ${
                isUnlocked
                  ? "bg-white text-gray-800 hover:bg-green-100 cursor-pointer"
                  : "bg-gray-300 text-gray-600 cursor-not-allowed opacity-70"
              }
            `}
            disabled={!isUnlocked} // Disable the button if not unlocked
          >
            <div
              className={`
                absolute top-3 right-3 w-8 h-8 rounded-full flex items-center justify-center
                font-bold text-lg
                ${
                  isUnlocked
                    ? "bg-green-500 text-white"
                    : "bg-gray-500 text-gray-200"
                }
              `}
            >
              {episode}
            </div>
            <p className="text-lg font-semibold mt-8 mb-2 px-2">
              {episodeName || t("Unnamed Episode")}{" "}
              {/* Display name or a fallback */}
            </p>
            {!isUnlocked && (
              <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40 rounded-2xl"></div>
            )}
          </button>
        );
      })}
    </div>
  );
}
